import React from 'react';
import './Header.css';
import { NavLink, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const noBgPages = [
    '/why',
    '/contact',
    '/book',
    '/packages',
    '/self-booking',
    '/hot-tours',
    '/rusttest',
    '/china',
    '/japan',
    '/georgia',
    '/vietnam',
    '/thailand',
    '/russia',
    '/maldives',
    '/turkey',
    '/egypt',
    '/uae',
    '/azerbaijan',
  ];
  const isNoBg = noBgPages.includes(location.pathname);

  return (
    <header className={`main-header ${isNoBg ? 'no-bg' : ''}`}>
      <div className="header-container">
        <NavLink to="/" className="logo-text">
          ASIAN TOUR
        </NavLink>

        <nav className="header-nav">
          <ul className="header-nav__list">
            <li>
              <NavLink to="/self-booking">Найти тур</NavLink>
            </li>
            <li>
              <NavLink to="/hot-tours">Горящие туры</NavLink>
            </li>
            <li>
              <NavLink to="/book">Бронируйте с нами</NavLink>
            </li>
            <li>
              <NavLink to="/why">Почему мы</NavLink>
            </li>
            <li>
              <NavLink to="/contact">Контакты</NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
